(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["v5-color-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v5-color-filter')) {
 class V5ColorFilter extends HTMLElement {
  connectedCallback() {
   this.details = this.querySelector('details');
   this.panel = this.querySelector('.v5-color-filter__panel');
   if (!this.details || !this.panel) return;
   this.onKey = this.onKey.bind(this);
   this.onResize = () => { if (this.details.open) this.placePanel(); };
   window.addEventListener('resize', this.onResize);
   this.details.addEventListener('toggle', () => {
    if (this.details.open) {
     this.placePanel();
     this.panel.setAttribute('role', 'dialog');
     this.panel.setAttribute('aria-modal', 'true');
     document.addEventListener('keydown', this.onKey);
     (this.querySelector('input:checked') || this.querySelector('button')).focus();
    } else {
     document.removeEventListener('keydown', this.onKey);
     this.panel.removeAttribute('role');
     this.panel.removeAttribute('aria-modal');
    }
   });
   this.querySelectorAll('[data-color-close]').forEach(button => button.addEventListener('click', () => this.close()));
   this.querySelector('form').addEventListener('submit', event => {
    event.preventDefault();
    const url = new URL(window.location.href);
    const form = new FormData(event.currentTarget);
    const colorName = 'filter.v.m.custom.browse_color';
    url.searchParams.delete(colorName);
    const color = form.get(colorName);
    if (color) url.searchParams.set(colorName, color);
    url.searchParams.delete('page');
    window.location.assign(url.href);
   });
  }
  disconnectedCallback() { document.removeEventListener('keydown', this.onKey); window.removeEventListener('resize', this.onResize); }
  placePanel() {
   if (!window.matchMedia('(min-width: 750px)').matches) {
    this.panel.classList.remove('v5-color-filter__panel--above');
    this.panel.style.removeProperty('--v5-color-space');
    return;
   }
   const rect = this.querySelector('summary').getBoundingClientRect();
   const below = window.innerHeight - rect.bottom - 20;
   const above = rect.top - 20;
   const opensAbove = below < 320 && above > below;
   this.panel.classList.toggle('v5-color-filter__panel--above', opensAbove);
   this.panel.style.setProperty('--v5-color-space', `${Math.max(180, opensAbove ? above : below)}px`);
  }
  close() { this.details.open = false; this.querySelector('summary').focus(); }
  onKey(event) {
   if (event.key === 'Escape') { event.preventDefault(); this.close(); return; }
   if (event.key !== 'Tab') return;
   const focusable = [...this.panel.querySelectorAll('button, input:not([disabled]), a[href]')].filter(el => el.getClientRects().length);
   const first = focusable[0], last = focusable[focusable.length - 1];
   if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
   else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
 }
 customElements.define('v5-color-filter', V5ColorFilter);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v5-gift-finder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v5-gift-finder')) {
 class V5GiftFinder extends HTMLElement {
  connectedCallback() {
   if (this.ready || this.dataset.complete !== 'true') return;
   this.ready = true;
   this.form = this.querySelector('[data-gift-form]');
   this.results = this.querySelector('.gf__results');
   this.cards = Array.from(this.querySelectorAll('[data-gift-card]'));
   this.labels = JSON.parse(this.querySelector('[data-gift-labels]').textContent);
   this.form.hidden = false;
   this.querySelector('[data-gift-next]').addEventListener('click', () => this.step('interest', true));
   this.querySelector('[data-gift-back]').addEventListener('click', () => this.step('budget', true));
   this.querySelector('[data-gift-edit]').addEventListener('click', () => { this.results.hidden = true; this.form.hidden = false; this.step('budget', true); this.syncUrl('questions'); });
   this.querySelector('[data-gift-all]').addEventListener('click', event => { event.preventDefault(); this.showAll(true); });
   this.form.addEventListener('submit', event => { event.preventDefault(); this.expanded = false; this.render(true); });
   this.querySelector('[data-gift-more]').addEventListener('click', () => { this.expanded = !this.expanded; this.render(false); });
   this.querySelector('[data-gift-within]').addEventListener('click', () => { this.form.elements.gift_interest.value = 'mixed'; this.expanded = true; this.render(true); });
   this.addEventListener('click', event => { const card = event.target.closest('[data-gift-card]'); if (card) this.emit('product_click', { product: card.dataset.productId }); });
   this.results.hidden = true;
   this.step('budget');
   const params = new URL(location.href).searchParams;
   const cap = params.get('gift_budget');
   const interest = params.get('gift_interest');
   if (['5000', '8000', '0'].includes(cap)) this.form.elements.gift_budget.value = cap;
   if (['sports', 'japanese', 'american', 'motorcycles', 'mixed'].includes(interest)) this.form.elements.gift_interest.value = interest;
   if (params.get('gift_view') === 'all') this.showAll(false);
   else if (params.get('gift_view') === 'results' && cap && interest) { this.expanded = params.get('gift_more') === '1'; this.render(false); }
   this.emit('view');
  }
  step(name, focus = false) {
   this.querySelectorAll('[data-gift-step]').forEach(step => { step.hidden = step.dataset.giftStep !== name; });
   const checked = this.form.querySelector('[name="gift_budget"]:checked');
   this.querySelector('[data-gift-budget-label]').textContent = checked.closest('label').innerText.trim();
   if (focus) this.form.querySelector('[data-gift-step="' + name + '"] input').focus({ preventScroll: true });
   this.emit(name === 'interest' ? 'budget_selected' : 'budget_step');
  }
  values() { return { cap: Number(this.form.elements.gift_budget.value), interest: this.form.elements.gift_interest.value }; }
  render(focus) {
   const { cap, interest } = this.values();
   const matches = this.cards.filter(card => (!cap || Number(card.dataset.price) <= cap) && (interest === 'mixed' || card.dataset.groups.split(' ').includes(interest)));
   let shortlist = matches.slice(0, 4);
   if (interest === 'mixed' && !this.expanded) {
    const chosen = new Set();
    ['sports', 'japanese', 'american', 'motorcycles'].forEach(group => { const pick = matches.find(card => !chosen.has(card) && card.dataset.groups.split(' ').includes(group)); if (pick) chosen.add(pick); });
    for (const card of matches) { if (chosen.size >= 4) break; chosen.add(card); }
    shortlist = matches.filter(card => chosen.has(card));
   }
   const visible = this.expanded ? matches : shortlist;
   const set = new Set(visible);
   this.cards.forEach(card => { card.hidden = !set.has(card); });
   this.form.hidden = true;
   this.results.hidden = false;
   this.querySelector('[data-gift-results-title]').textContent = this.labels.results;
   this.querySelector('[data-gift-results-intro]').textContent = this.labels.resultsIntro;
   this.querySelector('[data-gift-count]').textContent = this.labels.count.replace('__COUNT__', String(matches.length));
   const summary = this.querySelector('[data-gift-selection]');
   const b = this.form.querySelector('[name="gift_budget"]:checked').closest('label').innerText.trim();
   const i = this.form.querySelector('[name="gift_interest"]:checked').closest('label').querySelector('strong').textContent;
   summary.textContent = b + ' · ' + i; summary.hidden = false;
   this.querySelector('[data-gift-empty]').hidden = matches.length > 0;
   this.querySelector('[data-gift-edit]').hidden = false;
   const more = this.querySelector('[data-gift-more]'); more.hidden = matches.length <= 4; more.textContent = this.expanded ? this.labels.less : this.labels.more;
   this.syncUrl('results');
   if (focus) this.focusResults();
   this.emit('results', { count: matches.length });
  }
  showAll(focus) {
   this.cards.forEach(card => { card.hidden = false; });
   this.form.hidden = true; this.results.hidden = false;
   this.querySelector('[data-gift-results-title]').textContent = this.labels.all;
   this.querySelector('[data-gift-results-intro]').textContent = this.labels.allIntro;
   this.querySelector('[data-gift-count]').textContent = this.labels.count.replace('__COUNT__', String(this.cards.length));
   this.querySelector('[data-gift-selection]').hidden = true;
   this.querySelector('[data-gift-empty]').hidden = true;
   this.querySelector('[data-gift-more]').hidden = true;
   this.querySelector('[data-gift-edit]').hidden = false;
   this.syncUrl('all');
   if (focus) this.focusResults();
   this.emit('browse_all');
  }
  focusResults() { const h = this.querySelector('[data-gift-results-title]'); h.focus({ preventScroll: true }); h.scrollIntoView({ block: 'start', behavior: 'auto' }); }
  syncUrl(view) {
   const url = new URL(location.href);
   ['gift_view','gift_budget','gift_interest','gift_more'].forEach(key => url.searchParams.delete(key));
   if (view !== 'questions') url.searchParams.set('gift_view', view);
   if (view === 'results') { const { cap, interest } = this.values(); url.searchParams.set('gift_budget', cap); url.searchParams.set('gift_interest', interest); if (this.expanded) url.searchParams.set('gift_more', '1'); }
   url.hash = ''; history.replaceState(null, '', url);
  }
  emit(action, extra = {}) { this.dispatchEvent(new CustomEvent('v5:gift-finder', { bubbles: true, detail: { action, ...this.values(), ...extra } })); }
 }
 customElements.define('v5-gift-finder', V5GiftFinder);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v5-pdp-facts"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('v5-order-support')) {
 customElements.define('v5-order-support', class extends HTMLElement {
  connectedCallback() {
   this.trigger = this.querySelector('[data-v5-support-open]');
   this.dialog = this.querySelector('dialog');
   this.closeButton = this.querySelector('[data-v5-support-close]');
   if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
   this.openSupport = () => {
    if (this.dialog.open) return;
    this.returnFocus = document.activeElement;
    this.dialog.showModal();
    this.trigger.setAttribute('aria-expanded', 'true');
    this.closeButton?.focus({preventScroll:true});
   };
   this.closeSupport = () => this.dialog.close();
   this.onClose = () => {
    this.trigger.setAttribute('aria-expanded', 'false');
    const target = this.returnFocus?.isConnected ? this.returnFocus : this.trigger;
    requestAnimationFrame(() => { if (target.isConnected) target.focus({preventScroll:true}); });
   };
   this.onBackdrop = event => {
    if (event.target !== this.dialog) return;
    const bounds = this.dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.closeSupport();
   };
   this.trigger.addEventListener('click', this.openSupport);
   this.closeButton?.addEventListener('click', this.closeSupport);
   this.dialog.addEventListener('close', this.onClose);
   this.dialog.addEventListener('click', this.onBackdrop);
  }
  disconnectedCallback() {
   this.trigger?.removeEventListener('click', this.openSupport);
   this.closeButton?.removeEventListener('click', this.closeSupport);
   this.dialog?.removeEventListener('close', this.onClose);
   this.dialog?.removeEventListener('click', this.onBackdrop);
   if (this.dialog?.open) this.dialog.close();
  }
 });
}


document.addEventListener('click',event=>{
 const link=event.target.closest('[data-v5-model-help]');
 if(!link)return;
 const info=link.closest('product-info');
 const variant=info?.querySelector('product-form input[name="id"]')?.value;
 if(!/^\d+$/.test(variant||''))return;
 const url=new URL(link.href,location.origin);url.searchParams.set('variant',variant);link.href=url.pathname+url.search+url.hash;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["v5-tag-filters"] && !Shopify.designMode) return;
  try {
    (() => {
  const preservedKeys = [
    'filter.v.price.gte',
    'filter.v.price.lte',
    'filter.v.availability',
    'filter.v.m.custom.browse_color',
    'sort_by'
  ];

  function updateLink(link) {
    const navigation = link.closest('.v5-tag-filters[data-v5-collection-url]');
    if (!navigation) return;
    const current = new URL(window.location.href);
    const collection = new URL(navigation.dataset.v5CollectionUrl, current.origin);
    const base = link.dataset.v5TagBaseUrl || link.getAttribute('href');
    if (!base) return;
    const destination = new URL(base, current.origin);
    const withinCollection = (path) => path === collection.pathname || path.startsWith(`${collection.pathname}/`);
    if (collection.origin !== current.origin || destination.origin !== current.origin) return;
    if (!withinCollection(current.pathname) || !withinCollection(destination.pathname)) return;
    link.dataset.v5TagBaseUrl = base;
    preservedKeys.forEach((key) => {
      destination.searchParams.delete(key);
      current.searchParams.getAll(key).forEach((value) => destination.searchParams.append(key, value));
    });
    destination.searchParams.delete('page');
    if (destination.pathname === current.pathname) {
      current.searchParams.getAll('page').forEach((value) => destination.searchParams.append('page', value));
    }
    link.href = `${destination.pathname}${destination.search}${destination.hash}`;
  }

  function updateAllLinks() {
    document.querySelectorAll('.v5-tag-filters[data-v5-collection-url] a[href]').forEach(updateLink);
  }

  function updateEventLink(event) {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('.v5-tag-filters[data-v5-collection-url] a[href]');
    if (link) updateLink(link);
  }

  ['pointerdown', 'focusin', 'contextmenu', 'click', 'auxclick'].forEach((type) => {
    document.addEventListener(type, updateEventLink, true);
  });
  window.addEventListener('popstate', updateAllLinks);
  window.addEventListener('pageshow', updateAllLinks);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllLinks, { once: true });
  } else {
    updateAllLinks();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
